<template>
  <e-charts autoresize :options="dataGauge" auto-resize />
</template>
<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/gauge'

export default {
  components: {
    ECharts
  },
  props: {
    min: {
      type: [Number],
      required: true
    },
    max: {
      type: [Number],
      required: true
    },
    alertMin: {
      type: [Number],
      required: true
    },
    alertMax: {
      type: [Number],
      required: true
    },
    title: {
      type: [String],
      default: ''
    },
    value: {
      type: [Number],
      required: true
    },
    unit: {
      type: [String],
      required: true
    }
  },
  data () {
    return {
      app: this,
      dataGauge: {
        series: [{
          type: 'gauge',
          startAngle: 180,
          endAngle: 0,
          min: this.min,
          max: this.max,
          axisLine: {
            lineStyle: {
              width: 20,
              color: this.getRanges() /* [
                [0.25, '#EA5455'],
                [0.30, '#FF9F43'],
                [0.70, '#28C76F'],
                [0.75, '#FF9F43'],
                [1, '#EA5455']
              ] */
            }
          },
          axisTick: {
            distance: -30,
            length: 8,
            lineStyle: {
              color: '#fff',
              width: 2
            }
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: {
              color: '#fff',
              width: 4
            }
          },
          axisLabel: {
            color: 'auto',
            fontSize: 10,
            distance: -50
          },
          title: {
            offsetCenter: [0, '30%'],
            fontSize: 20
          },
          detail: {
            fontSize: 40,
            offsetCenter: [0, '-145%'],
            valueAnimation: true,
            formatter: this.formatter
          },
          data: [{
            value: this.value,
            name: this.title
          }]
        }]
      }
    }
  },
  methods: {
    formatter (value) {
      return parseFloat(value).toFixed(2) + this.unit
    },
    getRanges () {
      let c = 0
      const percent = 1 / (this.max - this.min)
      if (this.min < 0) { c = (this.min * -1) * percent }
      return [
        [(this.alertMin * percent) + c, '#EA5455'],
        // [(this.alertMin * percent) + c + (percent *5), '#FF9F43'],
        // [(this.alertMax * percent) + c - (percent *5), '#28C76F'],
        [(this.alertMax * percent) + c, '#28C76F'],
        [1, '#EA5455']
      ]
    },
    getRangeMax () {
      let tempMax = this.max
      while ((tempMax / 10) > this.min && (tempMax / 10) > this.value) {
        tempMax = tempMax / 10
      }
      return tempMax
    }
  },
  created () {
    this.getRanges()
  }
}
</script>
